export const Seccion = Object.freeze({
  MATERIAS_PRIMAS: 1,
  HERRAMENTALES: 2,
  TERMINACIONES: 3,
  PRESENTACION: 4,
  ENTREGA_FLETE: 5,
  TERCEROS: 6,
  IMPUESTOS: 7,
  GASTOS_FINANCIEROS: 8,
  INDIRECTOS: 9,
});
